import React, { useEffect } from 'react'
import { useModal } from 'hooks/useModal'

import 'steps/spot-the-diff/SpotTheDifferenceStep3.scss'

import { useDifferences } from 'steps/spot-the-diff/hooks/useDifferences'
import { useTimer } from 'steps/spot-the-diff/hooks/useTimer'
import { EndGameModal } from 'steps/spot-the-diff/components/Modal'
import Countdown from 'steps/shared/Countdown'
import DifferenceCounter from 'steps/spot-the-diff/components/DifferenceCounter'
import ImageContainer from 'steps/spot-the-diff/components/ImageContainer'

const SceneContainer = ({
  timeLimit,
  buttonText,
  differences,
  image1,
  image2,
  completeScene,
  started,
  startedScene,
  totalScenes,
  differenceSelected,
  idx,
  onSceneTimeOut,
  ...otherProps
}) => {
  const { showModal, toggle } = useModal()

  const { state, findDifference, endDifference } = useDifferences({
    initialDifferences: differences,
  })

  const { timeLeft, stopTimer } = useTimer({
    start: started,
    initialTimeLimit: timeLimit,
    onTimeout: () => {
      if (state.isWin) return
      if (totalScenes === idx + 1) toggle()
      endDifference()
      completeScene(idx, false)
      onSceneTimeOut({ currentScene: idx })
    },
  })

  useEffect(() => {
    if (state.isWin) {
      if (totalScenes === idx + 1) toggle()
      stopTimer()
      completeScene(idx, true)
    }
  }, [state.isWin])

  return (
    <div className="scene__wrapper">
      <EndGameModal
        isWin={state.isWin}
        open={showModal}
        onClose={toggle}
        totalScenes={totalScenes}
        {...otherProps}
      />
      <div className="spot-diff-info">
        <Countdown complete={state.isWin} currentTime={timeLeft} />
        <DifferenceCounter state={state} />
      </div>
      <div style={{ position: 'relative' }}>
        <div className="image-container">
          {!started && (
            <div className="start__layer">
              <button
                className="spot__button"
                onClick={() => startedScene(idx)}
              >
                {buttonText.toUpperCase() || 'START'}
              </button>
            </div>
          )}
          <ImageContainer
            differenceSelected={differenceSelected}
            start={started}
            image={image1}
            findDifference={findDifference}
            state={state}
          />
          <ImageContainer
            differenceSelected={differenceSelected}
            start={started}
            image={image2}
            findDifference={findDifference}
            state={state}
          />
        </div>
      </div>
    </div>
  )
}

export default SceneContainer
